const develop_tab_data = [
  {
    id: 0,
    title: "Programs",
    path: "/develop/programs",
  },
  {
    id: 1,
    title: "Actions",
    path: "/develop/actions",
  },
  {
    id: 2,
    title: "Config",
    //When we create config component here we need to change path
    path: "/develop/config",
  },
];

export default develop_tab_data;
